import React from 'react';
import { withTranslation } from 'react-i18next';
import { notification } from 'antd';

import "./index.css";


class ChList extends React.Component {
    constructor(props) {
        super(props);

        const { i18n, theme, urlParams } = props;

        this.app = theme.app || "";

        if (this.app === "") {
            throw new Error('App is mandatory!');
        }

        this.org = theme.org || "";

        if (this.org === "") {
            throw new Error('Org is mandatory!');
        }

        const urlLang = (urlParams['lang'] === 'fr') ? 'fr' : 'en';
        i18n.changeLanguage(urlLang);

        this.tvPlanId = urlParams['tvPlanId'] || 0;
        this.token = urlParams['token'] || "";
        this.org = urlParams['org'] || "";
        this.urlReferrer = urlParams['urlReferrer'] || "";
        this.config = theme.config;

        if (this.tvPlanId === 0 ||
            this.token === "" ||
            this.org === "" ||
            this.urlReferrer === "") {
            this.token = null;
            this.tvPlanId = 0;
            this.urlReferrer = "";
            this.org = theme.org || "";
        }
    }

    async componentDidMount() {
        this.tvConfig = await this.apiUrlFetch(this.props.theme.tvConfigFile);

        if (this.tvConfig == null || undefined === this.tvConfig.data) {
            throw new Error('Tv Config json file is required!');
        }

        if (undefined === this.tvConfig.data || undefined === this.tvConfig.data.plans) {
            throw new Error('Tv Config json structure is wrong!');
        }

        this.setState({loading: false});
    }

    async apiUrlFetch(url, data, method) {
        if (undefined === method) {
            method = 'GET';
        }

        try {
            let response = await fetch(url, {
                method: method,
                crossDomain: true,
                body: JSON.stringify(data),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'pragma':'no-cache',
                    'Cache-Control': 'no-cache',
                }
            });

            if (response == null) {
                throw new Error('Error: Response is null');
            }

            let json = await response.json();

            if (json == null) {
                throw new Error('Error: Json is null');
            }

            return json;
        }
        catch (error) {
            notification['warning']({
               message: 'An error has occurred while establishing the connection to the server.',
               description: 'Please, try to reload the page, and if the error persists, contact the support team.',
               top: 80,
               duration: 5
            });
            console.log(error);
            return null;
        }
    }

    render() {
        if ( !this.state) { return (<div>Loading...</div>);}
        if (this.state.loading) {
            return (<div>loading...</div>);
        }

        let tvc = this.tvConfig || {};
        let tvcd = tvc.data || {};
        let lineup = tvcd.lineup || {};
        let chKeys = Object.keys(lineup);
        let chCount = chKeys.length;
        if ( chCount < 1 ) {
            return (<div>Error loading tvconfig, please check configuration in theme.json</div>);
        }
        let channels = tvcd.channels || {};
        let chdb = tvcd.channel || {};

        let chs = [];
        //console.log(tvcd);

        //create a correctionMap
        let fixMap = {};
        let lineupCorrections = tvcd.lineupCorrections || {};
        for ( let ocode in lineupCorrections ) {
            let ncode = lineupCorrections[ocode] || null;
            if (ncode == null ) {continue;}
            fixMap[ncode] = ocode;
        }

        for( let cno of chKeys) {
            let ccode = lineup[cno] || "";
            if ( ccode.length < 1 ) { continue;}
            let chr = channels[ccode] || null;
            if ( chr == null ) {
                //let lcr = tvcd.lineupCorrections || {};
                let correctCode = fixMap[ccode] || null;

                if ( correctCode == null   ) {
                    chr = null;
                } else {
                    let achr = channels[correctCode] || {};
                    //console.log("FOUND:" , achr);
                    let cchr = chdb[ccode] || {};
                    //console.log(cchr);
                    chr = {...cchr,...achr};
                }

            }
            let tileIcon = "";
            let logoCode = null;
            let chrnz = chr || {};
            if ( typeof chrnz == "object") {
                tileIcon = chrnz.tileIcon || "";;
            }
            if ( tileIcon.length > 0 ) {
                let logo = process.env.PUBLIC_URL + "/chicons/" + tileIcon;
                logoCode = (<div className='chlogodiv'><img className='chicon' src={logo} alt={tileIcon} /></div>);
            } else {
                logoCode = (<div className='chlogodiv'><div className='chcode'>{ccode}</div></div>);
            }
            //console.log("chr-" + ccode,chr);
            let chname = chrnz.publicName || "";
            let ch = (
                <li key={`chline-${cno}`} className='chline'>
                    <div className='chno'>{cno}</div>
                    {logoCode}
                    <div className='chname'>{chname}</div>
                </li>
            );

            if ( chr == null ) {

            } else {
                chs.push(ch);
            }

        }

        return (<ul className='chlist'>{chs}></ul>);
    }
}

export default withTranslation('tvplan')(ChList);
